import {
  $applyNodeReplacement,
  DOMConversionOutput,
  ElementFormatType,
  LexicalNode,
  setNodeIndentFromDOM,
} from 'lexical';

import { CodeBlockNode } from './CodeBlockNode';

export const $createCodeBlockNode = (): CodeBlockNode => {
  return $applyNodeReplacement(new CodeBlockNode());
};

export const $isCodeBlockNode = (
  node: LexicalNode | null | undefined,
): node is CodeBlockNode => {
  return node instanceof CodeBlockNode;
};

export const $convertCodeBlockElement = (
  element: HTMLElement,
): DOMConversionOutput => {
  const node = $createCodeBlockNode();
  if (element.style) {
    node.setFormat(element.style.textAlign as ElementFormatType);
    setNodeIndentFromDOM(element, node);
  }
  return { node };
};
